import React from 'react';
import { cn } from '../../lib/utils';

const GradientButton = ({
  children,
  onClick,
  disabled = false,
  variant = 'primary',
  className = '',
  icon = null,
  size = 'default',
  type = 'button',
  fullWidth = false,
  ...props
}) => {
  // Mapping dei tipi di varianti
  const variantStyles = {
    primary: 'btn-gradient',
    success: 'btn-gradient btn-success',
    danger: 'btn-gradient btn-danger',
    secondary: 'btn-gradient btn-secondary'
  };

  // Mapping dei size
  const sizeStyles = {
    small: 'text-xs py-1 px-2',
    default: 'text-sm py-2 px-4',
    large: 'text-base py-3 px-6'
  };

  // Applica gli stili in base alle props
  const buttonClasses = cn(
    'relative inline-flex items-center justify-center rounded-md font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500',
    variantStyles[variant],
    sizeStyles[size],
    disabled ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-lg',
    fullWidth ? 'w-full' : '',
    className
  );

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {icon && <span className={`mr-2 ${size === 'small' ? 'text-xs' : ''}`}>{icon}</span>}
      {children}
      <div className="absolute inset-0 overflow-hidden rounded-md">
        <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 hover:opacity-20 transition-opacity duration-300 transform translate-x-full hover:translate-x-0"></span>
      </div>
    </button>
  );
};

export default GradientButton;